<template>
  <div class="py-2 px-6">
    <div class="flex justify-between mx-3 my-7">
      <div class="flex"><logo-icon></logo-icon></div>
      <div class="cursor-pointer lowercase text-primary">
        <span>www.{{ tenantName }}.com</span>
      </div>
    </div>
    <div class="mt-2 p-4">
      <div class="my-4">
        <span class="font-bold">Business Name:</span> <br />
        <span>{{ business.name }}</span>
      </div>
      <div class="my-4">
        <span class="font-bold">Email:</span> <br />
        <span>{{ business.email }}</span>
      </div>
      <div>
        <div>
          <div class="my-4 pb-6">
            <span class="font-bold">Time & Date</span> <br />
            <span>
              <span v-if="localAccountDetails">
                {{
                  $dayjs(localAccountDetails.updatedAt).format(
                    'hh:mm A | DD-MMM-YYYY'
                  )
                }}</span
              >
              <span v-else>
                {{
                  $dayjs(currentTransaction.updatedAt).format(
                    'hh:mm A | DD-MMM-YYYY'
                  )
                }}</span
              >
            </span>
          </div>
          <div
            class="border w-full border-gray-14 p-4 my-6 rounded-md shadow-md"
          >
            <div>
              <p class="font-bold mb-4 text-base">Local Currency Transfer</p>
              <p
                v-if="!isDepositTransaction"
                class="font-normal"
                style="word-break: normal"
              >
                <span class="font-bold">Note: </span>The exchange rate is valid
                till the end of the day. Please ensure you use the correct
                reference when making a deposit.
              </p>
              <div class="w-3/6 mt-10 pl-3">
                <div class="flex justify-between pb-2">
                  <p class="font-normal">You send exactly</p>
                  <div>
                    <p v-if="localAccountDetails" class="font-bold">
                      {{ parseAmount(localAccountDetails.amount.amount) }}
                      {{ country.currency }}
                    </p>
                    <p v-else class="font-bold">
                      {{ parseAmount(currentTransaction.depositedAmount) }}
                      {{ currentTransaction.depositedCurrency }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="!isDepositTransaction"
                  class="flex justify-between pb-2"
                >
                  <p class="font-normal">Amount Converted</p>
                  <div>
                    <p v-if="localAccountDetails" class="font-normal">
                      {{ parseAmount(localAccountDetails.amount.amount) }}
                      {{ country.currency }}
                    </p>
                    <p v-else class="font-normal">
                      {{ parseAmount(currentTransaction.depositedAmount) }}
                      {{ currentTransaction.depositedCurrency }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="!isDepositTransaction"
                  class="flex justify-between pb-2"
                >
                  <p class="font-normal">Exchange rate</p>
                  <div>
                    <p class="font-normal" v-if="localAccountDetails">
                      {{ exchangeRateBase }} {{ country.currency }} to $1
                    </p>
                    <p class="font-normal" v-else>
                      {{ transaction.exchange_rate }} {{ transaction.from }}
                      to $1
                    </p>
                  </div>
                </div>
              </div>
              <!--Bank account -->
              <div class="mt-10 pl-3">
                <div>
                  <p class="font-bold pb-2">Bank Account</p>
                  <div class="pb-2">
                    <p>
                      Account name:
                      <span class="font-bold">{{
                        paymentDetails.account_details.accountName
                      }}</span>
                    </p>
                  </div>
                  <div class="pb-2">
                    <p>
                      Account number:
                      <span class="font-bold">{{
                        paymentDetails.account_details.accountNumber
                      }}</span>
                    </p>
                  </div>
                  <div class="pb-2">
                    <p>
                      Bank name:
                      <span class="font-bold">{{
                        paymentDetails.account_details.bankName
                      }}</span>
                    </p>
                  </div>
                  <div class="flex items-center">
                    <p class="mr-2">Reference:</p>
                    <div class="font-bold">
                      <p v-if="localAccountDetails">
                        {{ localAccountDetails.reference }}
                      </p>
                      <p v-else>{{ transactionDetails.depositReference }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="italic font-semibold">Disclaimer</div>
        <div style="word-break: normal" class="italic text-xs">
          This document is strictly confidential communication to and solely for
          the use of the recipient and may not be reproduced or circulated
          without {{ tenantName }}'s' prior written consent. If you are not
          intended recipient, you may not disclose or use the information in
          this documentation in any way.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import localDeposit from '@/mixins/localDeposit.js'
import { ParseLocalToUsd, ParseAmount } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'

export default {
  mixins: [localDeposit, country],
  data () {
    return {}
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    parseLocalToUsd (val) {
      return ParseLocalToUsd(val, this.exchangeRateBase)
    },
    parseAmount (val) {
      return ParseAmount(val)
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  computed: {
    isDepositTransaction () {
      return this.type === 'deposit'
    },
    tenantName () {
      return process.env.VUE_APP_TENANT_TITLE
    },
    currentTransaction () {
      return this.$store.state.transactions.currentTransaction
    },
    transactionDetails () {
      return this.$store.state.transactions.transactionDetails
    },
    transaction () {
      return this.$store.state.transactions.transactionDetails
        .transferInstruction
    },
    paymentDetails () {
      const details = this.localAccountDetails
        ? this.$store.state.transactions.localDepositInfo.paymentDetails
        : this.transaction
      return details
    },
    localAccountDetails () {
      const details = this.$store.state.transactions.localDepositInfo
      if (details && Object.keys(details).length > 0) {
        const details = this.$store.state.transactions.localDepositInfo
        return details
      }
      return null
    },
    business () {
      return this.$store.state.auth.business
    }
  }
}
</script>
<style scoped></style>
